module.exports = __webpack_public_path__ + "static/media/internaship_pragram.3438b9d3.jpg";